// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectablePill_wrapper__GuNrq","selected":"SelectablePill_selected__R+s4B","unselected":"SelectablePill_unselected__bi5rN"};